import React from "react";
import ReactCountryFlag from "react-country-flag";
import ReactTooltip from "react-tooltip";
const numFormat = (num) => {
  if (!isNaN(num)) {
    if (!!num && num > 1000000000000) {
      return (num / 1000000000000).toFixed(2) + "T";
    } else if (!!num && num > 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (!!num && num > 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (!!num && num > 1000) {
      return (num / 1000).toFixed(2) + "K";
    } else return num.toFixed(2);
  } else return num;
};
export default class TradeRouteThreeLevel extends React.Component {
  state = {
    traderouteData: [],
    mappingFieldData: [],
  };
  componentDidMount() {
    this.setState({
      mappingFieldData: this.props.mappingFieldData ? this.props.mappingFieldData : [],
      traderouteData: this.props.data ? this.props.data : [],
    });
  }
  redirectingUser(data1) {
    let tempanalyticsViewAllKey = !!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "";
    let tempfilter_value1 = !!data1[0] && data1[0] !== "" ? data1[0] : "";
    let tempfilter_value2 = !!data1[1] && data1[1] !== "" ? data1[1] : "";
    let tempfilter_value3 = !!data1[2] && data1[2] !== "" ? data1[2] : "";
    this.props.mapClickedFilterKey(tempanalyticsViewAllKey, tempfilter_value1, tempfilter_value2, tempfilter_value3);
  }
  render() {
    const suppress = !!this.props.suppressChartFilterInteractions;
    return (
      <>
        {!!this && !!this.state && !!this.state.traderouteData && this.state.traderouteData.length !== 0 ? (
          <div className="table-responsive">
            <table className="table" cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <td scope="row" className="py-0">
                    {this.state.mappingFieldData && this.state.mappingFieldData.headerOne ? this.state.mappingFieldData.headerOne : ""}
                  </td>
                  <td className="py-0"></td>
                  <td className="py-0">{this.state.mappingFieldData && this.state.mappingFieldData.headerTwo ? this.state.mappingFieldData.headerTwo : ""}</td>
                  <td className="py-0"></td>
                  <td className="py-0">{this.state.mappingFieldData && this.state.mappingFieldData.headerThree ? this.state.mappingFieldData.headerThree : ""}</td>
                </tr>
              </thead>
              <tbody>
                {this.state.traderouteData.map((item, index) => (
                  <tr key={index} className="trade_route_table_four_level" onClick={suppress ? undefined : this.redirectingUser.bind(this, [item[this.state.mappingFieldData.filterOne], item[this.state.mappingFieldData.filterTwo], item[this.state.mappingFieldData.filterThree]])}>
                    <td scope="row">
                      <a {...(!suppress ? { "data-tip": true, "data-for": "tradeRouteLevelThree" + index + this.props.headerLabel } : {})}>
                        {this.state.mappingFieldData.cityOne && item[this.state.mappingFieldData.cityOne] && this.state.mappingFieldData.stateOne && item[this.state.mappingFieldData.stateOne] ? <div>{item[this.state.mappingFieldData.keyOne] + ", " + item[this.state.mappingFieldData.stateOne]}</div> : this.state.mappingFieldData.cityOne && item[this.state.mappingFieldData.cityOne] ? <div>{item[this.state.mappingFieldData.cityOne].toUpperCase()}</div> : <></>}
                        <span className="d-block">
                          <span>{item[this.state.mappingFieldData.keyOneCountryCode] ? <ReactCountryFlag className="country-flag" countryCode={item[this.state.mappingFieldData.keyOneCountryCode]} svg /> : <></>}</span>
                          {item[this.state.mappingFieldData.keyOne] ? item[this.state.mappingFieldData.keyOne].toUpperCase() : ""}
                        </span>
                      </a>
                    </td>
                    <td className="text-center">
                      <a {...(!suppress ? { "data-tip": true, "data-for": "tradeRouteLevelThree" + index + this.props.headerLabel } : {})}>
                        <span className="d-block">
                          {numFormat(item.value)}
                          {this.props.mainLabel ? (this.props.mainLabel === "Weight (kg)" ? " kg" : this.props.mainLabel.includes("%") ? this.props.mainLabel : " " + this.props.mainLabel) : " Shipments"}
                        </span>
                        <span className="d-block">
                          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1644486417/intel/analytics/analytics-arrow_m7vvvw.svg" alt="..." className="img-fluid" />
                        </span>
                        <span className="d-block">&nbsp;</span>
                      </a>
                    </td>
                    <td>
                      <a {...(!suppress ? { "data-tip": true, "data-for": "tradeRouteLevelThree" + index + this.props.headerLabel } : {})}>
                        {this.state.mappingFieldData.cityTwo && item[this.state.mappingFieldData.cityTwo] ? <div>{item[this.state.mappingFieldData.cityTwo].toUpperCase()}</div> : <></>}
                        <span className="d-block">
                          <span>{item[this.state.mappingFieldData.keyTwoCountryCode] ? <ReactCountryFlag className="country-flag" countryCode={item[this.state.mappingFieldData.keyTwoCountryCode]} svg /> : <></>}</span>
                          {item[this.state.mappingFieldData.keyTwo] ? item[this.state.mappingFieldData.keyTwo].toUpperCase() : ""}
                        </span>
                      </a>
                    </td>
                    <td className="text-center">
                      <a {...(!suppress ? { "data-tip": true, "data-for": "tradeRouteLevelThree" + index + this.props.headerLabel } : {})}>
                        <span className="d-block">
                          {numFormat(item.value)}
                          {this.props.mainLabel ? (this.props.mainLabel === "Weight (kg)" ? " kg" : this.props.mainLabel.includes("%") ? this.props.mainLabel : " " + this.props.mainLabel) : " Shipments"}
                        </span>
                        <span className="d-block">
                          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1644486417/intel/analytics/analytics-arrow_m7vvvw.svg" alt="..." className="img-fluid" />
                        </span>
                        <span className="d-block">&nbsp;</span>
                      </a>
                    </td>
                    <td>
                      <a {...(!suppress ? { "data-tip": true, "data-for": "tradeRouteLevelThree" + index + this.props.headerLabel } : {})}>
                        {this.state.mappingFieldData.cityThree && item[this.state.mappingFieldData.cityThree] ? <div>{item[this.state.mappingFieldData.cityThree].toUpperCase()}</div> : <></>}
                        <span className="d-block">
                          <span>{item[this.state.mappingFieldData.keyThreeCountryCode] ? <ReactCountryFlag className="country-flag" countryCode={item[this.state.mappingFieldData.keyThreeCountryCode]} svg /> : <></>}</span>
                          {item?.[this?.state?.mappingFieldData?.keyThree]?.toUpperCase()}
                        </span>
                      </a>
                    </td>
                    {item.marketShare ? (
                      suppress ? (
                        <span className="tw-text-xs tw-text-gray-500">Share {item.marketShare.toFixed(2)}%</span>
                      ) : (
                        <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={"tradeRouteLevelThree" + index + this.props.headerLabel}>
                          Market Share {item.marketShare.toFixed(2)}% <br />
                          <hr />
                          Click to Apply Filter
                        </ReactTooltip>
                      )
                    ) : (
                      ""
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
